import { apiConfig } from '../api-config';

export const getTicket = async (cdTerritory: any) => {
  return apiConfig
    .post('api/Ticket/get-tickets-by-cdterritory', { cdTerritory })
    .then((resp) => resp.data.objectResult)
    .catch((err) => ({ hasErrors: true, err }));
};
